module.exports = "/_next/static/images/CollectDataTabs-1-xs-2408ddab47d777807428093dd5185e2e.webp";